// extracted by mini-css-extract-plugin
module.exports = {"moreLinks":"_3pkYucmK9fFFoyQv","companyLink":"_3WRKt0MmETkX-HYa"};